const initialState = {
  userInfo: {}
};

const UserInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'userInfo':
      return {
        ...state,
        userInfo: { ...state.userInfo, ...action.payload }
      };
    default:
      return state;
  }
};
export default UserInformationReducer;
